import {NavItem} from '../vertical-sidebar/menu-list-item/nav-item';

export const navItems: NavItem[] = [
    {
        displayName: 'Dashboard',
        iconName: 'dashboard',//change icon
        roles: ['admin', 'employee'],
        route: 'dashboards/dashboard1'
        // route: 'dashboards/arcon-dashboard'

    },
    {
        displayName: 'My Account',
        iconName: 'account',
        roles: ['admin', 'employee', 'customer', 'depot_user'],
        route: 'my-account',
    },
    // REMOVE comments after the pages are implemented

    // {
    //   displayName: 'My Dashboard',
    //   iconName: 'dashboard',
    //   roles: ['customer', 'admin'],
    //   route: 'client-dashboard/dashboard'
    // },
    {
        displayName: 'My Orders',
        iconName: 'package',
        roles: ['customer', 'admin'],
        route: 'client-dashboard/my-orders'
    },
    // {
    //   displayName: 'Offers for you',
    //   iconName: 'gift-card',
    //   roles: ['customer', 'admin'],
    //   route: 'client-dashboard/offers-for-you'
    // },
    {
        displayName: 'Company Profile',
        iconName: 'office',
        roles: ['customer', 'admin'],
        route: 'client-dashboard/company-profile'
    },
    { // enable when chat needed
        displayName: 'Chat',
        iconName: 'chat',
        roles: ['customer', 'admin', 'depot_user'],
        route: 'apps/chat'
    },
    // {
    //   displayName: 'TMS',
    //   iconName: 'region',
    //   roles: ['admin', 'employee', 'customer', 'depot_user'],
    //   route: 'dashboards/tms-dashboard',
    // }
    // {
    //   displayName: 'Master Management',
    //   iconName: 'master-management',
    //   roles: ['admin', 'employee'],
    //   children: [
    //     {
    //       displayName: 'Container Master',
    //       iconName: 'container-solid',
    //       route: 'dashboards/master-dashboard',
    //       child: true
    //     },
    //     {
    //       displayName: 'Depot Master',
    //       iconName: 'depot',
    //       route: 'dashboards/depot-dashboard',
    //       child: true
    //     },
    //     {
    //       displayName: 'Region Master',
    //       iconName: 'region',
    //       route: 'dashboards/region-dashboard',
    //       child: true
    //     },
    //     {
    //       displayName: 'User Master',
    //       iconName: 'users',
    //       route: 'dashboards/user-dashboard',
    //       child: true
    //     },
    //     {
    //       displayName: 'Department Master',
    //       iconName: 'department',
    //       route: 'dashboards/department-dashboard',
    //       child: true
    //     },
    //     {
    //       displayName: 'Role Master',
    //       iconName: 'role',
    //       route: 'dashboards/role-dashboard',
    //       child: true
    //     },
    //     {
    //       displayName: 'Currency Master',
    //       iconName: 'currency',
    //       route: 'dashboards/currency-dashboard',
    //       child: true
    //     },
    //     {
    //       displayName: 'Customer Master',
    //       iconName: 'customer',
    //       route: 'dashboards/customer-dashboard',
    //       child: true
    //     },
    //     {
    //       displayName: 'Charge Master',
    //       iconName: 'charge',
    //       route: 'dashboards/charge-dashboard',
    //       child: true
    //     },
    //     {
    //       displayName: 'User Service Mapping',
    //       iconName: 'charge',
    //       route: 'dashboards/user-service-mapping-dashboard',
    //       child: true
    //     },
    //   ]
    // },

    // {
    //   displayName: 'One-way New way',
    //   iconName: 'one-way',
    //   roles: ['employee', 'admin'],
    //   children: [
    //     {
    //       displayName: 'Request',
    //       iconName: 'container-solid',
    //       route: 'one-way/request',
    //       child: true
    //     },
    //     {
    //       displayName: 'Insurance Master',
    //       iconName: 'shield',
    //       route: 'one-way/insurance-master',
    //       child: true
    //     },
    //     {
    //       displayName: 'Request Processing',
    //       iconName: 'container-solid',
    //       route: 'one-way/request-processing',
    //       child: true
    //     }
    //   ]
    // },
    // {
    //   displayName: 'Click to Trade',
    //   iconName: 'trade',
    //   route: 'dashboards/dashboard2',
    //   roles: ['customer', 'admin', 'employee'],
    // },

    // {
    //   displayName: 'Lease with Ease',
    //   iconName: 'lease',
    //   route: 'dashboards/dashboard3',
    //   roles: ['customer', 'admin', 'employee'],
    // },

    // {
    //   displayName: 'Procurement',
    //   iconName: 'procurement',
    //   roles: ['admin', 'employee'],
    // },

    // {
    //   displayName: 'Stock Management',
    //   iconName: 'stock-management',
    //   roles: ['admin', 'employee'],
    // },

    // {
    //   displayName: 'Revenue',
    //   iconName: 'revenue',
    //   roles: ['admin', 'employee'],
    // },

    // {
    //   displayName: 'Analytics & Reporting',
    //   iconName: 'analytics',
    //   roles: ['admin', 'employee'],
    // },


    // {
    //   displayName: 'Invoices',
    //   iconName: 'post-booking',
    //   roles: ['customer', 'admin', 'depot_user'],
    // },
];
